import React from "react";
import styled from "styled-components";

const Arrow = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      color={color}
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-arrow-down"
    >
      <line x1="12" y1="4" x2="12" y2="20"></line>
      <polyline points="18 14 12 20 6 14"></polyline>
    </svg>
  );
};
export const StyledArrow = styled(Arrow)`
  transform: rotate(90deg);
  fill: red;
  color: red;
`;

export default Arrow;
